import { ISearchWidget } from 'features/search-widget';

const wotifSearchWidgetConfig: Record<string, ISearchWidget> = {
  'au-wotif': {
    branding: {
      logo: {
        url: 'https://www.wotif.com/_dms/header/logo.svg?siteid=70125&locale=en_AU&3ec60977',
        description: 'Wotif.com.au',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
      {
        id: 'flights',
        type: 'FLIGHTS',
      },
    ],
    search: {
      hostname: 'www.wotif.com.au',
      searchParams: {
        siteid: '70125',
        langid: '3081',
      },
      stays: {
        pathname: '/Hotel-Search',
      },
      flights: {
        pathname: '/Flights-Search',
        dateFormat: 'd/M/yyyy',
      },
    },
  },
};

export { wotifSearchWidgetConfig };
